import styled from 'styled-components';

export const ShowMoreButton = styled.button`
  width: 100%;
  ${({ theme }) => theme.kallisto.mixins.font('Body')};
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  border: 0;
  text-align: left;
  background-color: white;
  padding: 16px 0 0;
  border-radius: 8px;
  cursor: pointer;
`;
